export default {
  computed: {
    isPrasymasSeima() {
      return this.prasymasTipas && this.prasymasTipas.includes('seima')
    },
    isPrasymasBendra() {
      return this.prasymasTipas && this.prasymasTipas.includes('bendra')
    },
    isPrasymasPirmenybe() {
      return this.prasymasTipas && this.prasymasTipas.includes('pirmenybe')
    },
    isPrasymasNuoma() {
      return this.prasymasTipas && this.prasymasTipas.includes('nuoma')
    },
    isPrasymasPanauda() {
      return this.prasymasTipas && this.prasymasTipas.includes('panauda')
    },
    isPrasymasSubnuoma() {
      return this.prasymasTipas && this.prasymasTipas.includes('subnuomos')
    },
    isPrasymasPreliminari() {
      return this.prasymasTipas && this.prasymasTipas.includes('preliminari')
    },
    isPrasymasIregistravimas() {
      return this.prasymasTipas && this.prasymasTipas.includes('iregistravimas')
    },
    isPrasymasPerkelimas() {
      return this.prasymasTipas && this.prasymasTipas.includes('perkelimas')
    },
    isPrasymasPakeitimas() {
      return this.prasymasTipas && this.prasymasTipas.includes('pakeitimas')
    },
    isPrasymasNutraukimas() {
      return this.prasymasTipas && this.prasymasTipas.includes('nutraukimas')
    },
    isPrasymasIsregistravimas() {
      return (
        this.prasymasTipas && this.prasymasTipas.includes('isregistravimas')
      )
    },
  },
}
